module.exports = __webpack_public_path__ + "static/img/nk_logo.c8ae29a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/nk_logo.png
// module id = 8RZl
// module chunks = 97